import React from "react";
import { Navigate } from "react-router-dom";

const AuthRedirect = ({ children }) => {
    const token = localStorage.getItem("token");
    const isAuth = token !== null;

    if (isAuth) {
        return <Navigate to="/home" replace />;
    }

    return children;
};

export default AuthRedirect;